var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.25C0 12.1789 1.67893 10.5 3.75 10.5C5.82107 10.5 7.5 12.1789 7.5 14.25V30C3.35786 30 0 26.6421 0 22.5V14.25Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5H19.5V30H7.5C3.35786 30 0 26.6421 0 22.5V22.5Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12 12.5817 15.5817 9 20 9V9V30H12V17Z",
    fill: "#606060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 8.25C40.5 6.17893 42.1789 4.5 44.25 4.5V4.5C46.3211 4.5 48 6.17893 48 8.25V22.5C48 26.6421 44.6421 30 40.5 30V30V8.25Z",
    fill: "#606060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 9V9C29.6421 9 33 12.3579 33 16.5V21H25.5V9Z",
    fill: "#424242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C12 12.3579 15.3579 9 19.5 9H25.5C29.6421 9 33 12.3579 33 16.5V16.5H12V16.5Z",
    fill: "#767676"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 0H40.5C44.6421 0 48 3.35786 48 7.5V7.5H34.5C30.3579 7.5 27 4.14214 27 0V0Z",
    fill: "#424242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 22.5H48V22.5C48 26.6421 44.6421 30 40.5 30H33C28.8579 30 25.5 26.6421 25.5 22.5V22.5Z",
    fill: "#767676"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.75,
    cy: 3.75,
    r: 3.75,
    fill: "#CC141D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6ceb15fb7754911708d9d272f6cd413.svg";
export { ForwardRef as ReactComponent };